module.exports = __webpack_public_path__ + "img/cooperation6.fa02ca24.png";